import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// Forces banned accounts onto /banned no matter what they try to open.
export default function BannedGate({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("nc_user")); } catch { return null; }
  });

  useEffect(() => {
    const sync = () => {
      try { setUser(JSON.parse(localStorage.getItem("nc_user"))); } catch { setUser(null); }
    };
    window.addEventListener("storage", sync);
    const interval = setInterval(sync, 1500);
    return () => { window.removeEventListener("storage", sync); clearInterval(interval); };
  }, []);

  useEffect(() => {
    if (user?.banned && location.pathname !== "/banned") {
      navigate("/banned", { replace: true });
    }
  }, [user, location.pathname, navigate]);

  return children;
}
